import React, { useState } from "react";
import Header from "../../../Components/Header/Header";
import Footer from "../../../Components/Footer/Footer";
import "../ChangePassword/ChangePassword.css";
import { FaLock } from "react-icons/fa";
import { LuEyeOff, LuEye } from "react-icons/lu";
import { toast } from "react-toastify";
import { APIUrl, APIUrlToken, getIsUser } from "../../../Utils/Utils";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const ChangePassword = () => {
  const [oldpassword, setOldPassword] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const navigate = useNavigate()

  const userLoginDetails = getIsUser();
  const handleOldPasswordChange = (e) => {
    setOldPassword(e.target.value);
  };
  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const handleConfirmPasswordChange = (e) => {
    setConfirmPassword(e.target.value);
  };

  const toggleShowPassword = () => {
    setShowPassword((prevState) => !prevState);
  };
  const toggleShowOldPassword = () => {
    setShowOldPassword((prevState) => !prevState);
  };

  const toggleShowConfirmPassword = () => {
    setShowConfirmPassword((prevState) => !prevState);
  };

  const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_])[A-Za-z\d\W_]{8,}$/;

  const validateFields = () => {
    if (!oldpassword.trim()) {
      toast.error("Please enter your old Password");
      return false;
    }
    if (!password.trim()) {
      toast.error("Please enter Password");
      return false;
    }
    if (!passwordRegex.test(password)) {
      toast.error(
        "Password must contain at least 8 characters, including one uppercase, one lowercase, one special symbol, and one number"
      );
      return false;
    }
    if (!confirmPassword.trim()) {
      toast.error("Please enter Confirm Password");
      return false;
    }

    if (password !== confirmPassword) {
      toast.error("Please enter Confirm Password same as new password");
      return false;
    }

    return true;
  };

  const handlePassWordClick = () => {
    if (!validateFields()) return;
    const data = {
      "identifier": userLoginDetails?.user_email,
      "old_password": oldpassword,
      "new_password": password
    }
    const url = `${APIUrl()}/v1/local/auth/change-password`;
    const option = {
      method: "POST",
      headers: {
        "X-API-Key": APIUrlToken(),
      },
      data: data,
      url: url,
    };

    axios(option)
      .then((response) => {
        setOldPassword("")
        setPassword("")
        setConfirmPassword("")
        localStorage.clear()
        navigate("/Login")
        toast.success("Your password has been changed successfully. Please login again with new password.");

      })
      .catch((error) => {
        console.error("Error fetching teams data:", error);
      });
  };

  return (
    <>
      <Header />
      <div className="page-main-container-aboutus">
        <div className="content-section-changepass">
          <h3>Change Password</h3>
          <p className="headline-changepass">
            Your new password must be different from previously used passwords.
          </p>
          <div className="profile-container-changepass">
            <div className="profile-card-changepass">
              <div className="input-section-changepass">
                <div className="input-group-changepass">
                  <div className="input-icon-changepass">
                    <FaLock />
                  </div>
                  <input
                    type={showOldPassword ? "text" : "password"}
                    className="form-control-changepass"
                    id="oldpassword"
                    name="oldpassword"
                    placeholder="Old Password"
                    value={oldpassword}
                    onChange={handleOldPasswordChange}
                  />
                  {showOldPassword ? (
                    <LuEye className="eye-svg" onClick={toggleShowOldPassword} />
                  ) : (
                    <LuEyeOff className="eye-svg" onClick={toggleShowOldPassword} />
                  )}
                </div>
              </div>
              <div className="input-section-changepass">
                <div className="input-group-changepass">
                  <div className="input-icon-changepass">
                    <FaLock />
                  </div>
                  <input
                    type={showPassword ? "text" : "password"}
                    className="form-control-changepass"
                    id="password"
                    name="password"
                    placeholder="Password"
                    value={password}
                    onChange={handlePasswordChange}
                  />
                  {showPassword ? (
                    <LuEye className="eye-svg" onClick={toggleShowPassword} />
                  ) : (
                    <LuEyeOff className="eye-svg" onClick={toggleShowPassword} />
                  )}
                </div>
              </div>

              <div className="input-section-changepass">
                <div className="input-group-changepass">
                  <div className="input-icon-changepass">
                    <FaLock />
                  </div>
                  <input
                    type={showConfirmPassword ? "text" : "password"}
                    className="form-control-changepass"
                    id="confirmPassword"
                    name="confirmPassword"
                    placeholder="Confirm Password"
                    value={confirmPassword}
                    onChange={handleConfirmPasswordChange}
                  />
                  {showConfirmPassword ? (
                    <LuEye className="eye-svg" onClick={toggleShowConfirmPassword} />
                  ) : (
                    <LuEyeOff className="eye-svg" onClick={toggleShowConfirmPassword} />
                  )}
                </div>
              </div>

              <div className="button-section-changepass">
                <button onClick={handlePassWordClick}>Change Password</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ChangePassword;
